<template>
  <section class="section is-marginless font-style-family">
    <div v-if="step === 0">
      <h3 class="title-box page-title">Is this company for a new organization ?</h3>
          <div class="button-box-container">
            <button class="button-box" v-on:click="step = 1;">
              <div class="button-box-icon">
                <svg width="33" height="24" viewBox="0 0 33 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M29.0134 0.662072C29.7523 -0.158948 31.0169 -0.225504 31.8379 0.513414C32.659 1.25233 32.7255 2.51691 31.9866 3.33793L13.9866 23.3379C13.1717 24.2434 11.7434 24.2162 10.9636 23.2804L0.963558 11.2804C0.25643 10.4318 0.371078 9.17069 1.21963 8.46356C2.06819 7.75643 3.32932 7.87108 4.03644 8.71963L12.5582 18.9457L29.0134 0.662072Z" fill="#00A8A3"/>
                </svg>
              </div>
              <div class="button-box-text button-box-text-container">
                Yes
              </div>
            </button>

            <button class="button-box" v-on:click="step = 2">
              <div class="button-box-icon">
                <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.18629 0.686514C0.405239 1.46756 0.40524 2.73389 1.18629 3.51494L9.43587 11.7645C9.56605 11.8947 9.56604 12.1058 9.43587 12.2359L1.18629 20.4855C0.40524 21.2666 0.405239 22.5329 1.18629 23.3139C1.96734 24.095 3.23367 24.095 4.01472 23.3139L12.2643 15.0644C12.3945 14.9342 12.6055 14.9342 12.7357 15.0644L20.9853 23.3139C21.7663 24.095 23.0327 24.095 23.8137 23.3139C24.5948 22.5329 24.5948 21.2666 23.8137 20.4855L15.5641 12.2359C15.434 12.1058 15.434 11.8947 15.5641 11.7645L23.8137 3.51494C24.5948 2.73389 24.5948 1.46756 23.8137 0.686514C23.0327 -0.0945348 21.7663 -0.0945347 20.9853 0.686514L12.7357 8.93609C12.6055 9.06627 12.3945 9.06627 12.2643 8.93609L4.01472 0.686514C3.23367 -0.0945347 1.96734 -0.0945348 1.18629 0.686514Z" fill="#D93A4B"/>
                </svg>
              </div>
              <div class="button-box-text button-box-text-container">
                No
              </div>
            </button>
          </div>
    </div>
    <section class="section is-marginless" style="padding-bottom: 0px">
    <div v-if="step !== 0" class="columns is-centered">
      <div class="column is-half">
        <button class="back-button" @click="back" >
            <div class="back-button-icon">
                <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.91421 6L7.20711 10.2929C7.59763 10.6834 7.59763 11.3166 7.20711 11.7071C6.81658 12.0976 6.18342 12.0976 5.79289 11.7071L0.792893 6.70711C0.402369 6.31658 0.402369 5.68342 0.792893 5.29289L5.79289 0.292893C6.18342 -0.0976311 6.81658 -0.0976311 7.20711 0.292893C7.59763 0.683418 7.59763 1.31658 7.20711 1.70711L2.91421 6Z" fill="#60646F"/>
                </svg>
            </div>
            <div class="back-button-text">
                Back
            </div>
        </button>
      </div>
    </div>
    </section>
      <div v-if="step===1">
          <OrganizationSignup @step="handleStep" ></OrganizationSignup>
      </div>
      <div v-if="step===2">
          <CompanySignup :step="step"></CompanySignup>
      </div>
    </section>
</template>

<script>

  import CompanySignup from './CompanySignup.vue'
  import OrganizationSignup from './OrganizationSignup.vue'
  import _ from 'lodash';
  export default {

    name: 'CompanySignupPage',
    components: {
      OrganizationSignup,
      CompanySignup,
    },

    data () {
      return {
        step: 0,
        prvStep: 0,
      }
    },

    mounted(){
      if(Object.keys(this.$route.params).length !== 0){
        if(this.$route.params.id === "liverydesk"){
          this.domain = "LiveryDesk";
          this.domainURL = "liverydesk.com";
        }
        else{
          this.$router.push('CompanySignup');
        }
      }

    },

    methods :{
      back(){
        this.step = this.prvStep;
        this.prvStep = 0;
      },
      handleStep({ step, prvStep}){
        this.step = step;
        this.prvStep = prvStep;
      }

    }

  }

</script>
<style>
  .font-style-family {
    font-family: "CircularXX";
    font-style: normal;
  }

  .page-title {

    font-weight: 500;
    font-size: 28px;
    line-height: 40px;
    letter-spacing: -0.09px;
    color: #252935;
    text-align: center;
  }

  .title-box {
    display: block;
    width:419px;
    height:120px;
    margin: 27px auto 0;

  }

  .button-box {
    width: 122px;
    height: 116px;
    background: #FFFFFF;
    border: 1px solid #A5A9B1;
    border-radius: 8px;
  }

  .button-box-container {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 0px;
    gap: 24px;

    width: 268px;
    height: 116px;
    margin: 44px auto 0px;
  }

  .button-box:hover {
    border: 1px solid #60646F;
  }

  .button-box:hover div {
    color: #252935;
  }

  .button-box-icon {
    position: relative;
    top: -8px;
  }

  .button-box-text {
    font-family: "CircularXX";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    align-items: center;
    text-align: center;
    color: #60646F;

  }

  .button-box-text-container {
    position: relative;
    top: 19px;
  }

  .back-button {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 6px 16px 6px 8px;
    gap: 4px;
    width: 54px;
    height: 32px;
    border: none;
    border-radius: 32px;
    flex: none;
    order: 0;
    flex-grow: 0;
    background-color: #FFFFFF;
  }

  .back-button-text {
    width: 32px;
    height: 20px;
    font-family: 'CircularXX';
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: #60646F;
    flex: none;
    order: 1;
    flex-grow: 0;
  }

  .back-button-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 6px 16px 6px 8px;
    gap: 4px;
    width: 54px;
    height: 32px;
    border-radius: 32px;
  }

  .back-button-icon {
    padding-top: 3px;
    width: 24px;
    height: 24px;
    flex: none;
    order: 0;
    flex-grow: 0;
  }

  @font-face {
    font-family: 'CircularXX';
    src: url('../common/fonts/CircularXXTT-Regular.ttf') format('truetype');
    font-weight: 400;
    font-display: swap;
  }

  @font-face {
    font-family: 'CircularXX';
    src: url('../common/fonts/CircularXXTT-Bold.ttf') format('truetype');
    font-weight: 500;
    font-display: swap;
  }
</style>





// WEBPACK FOOTER //
// src/components/company/CompanySignupPage.vue